import styled from 'styled-components';

// tslint:disable-next-line:variable-name
const CommonSection = styled.section<{}>(({ theme }) => `
  margin-bottom: ${theme.spacing.large}px;
`);

export default CommonSection;
